import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Offer } from "./Offer";
import { Order } from "./Order";
import ProductVariation from "./ProductVariation";
import Product from "./Product";
import Model from "./Model";
export class OrderLine extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'order_line_id',
      content: null
    });
    _defineProperty(this, "OrderLineId", {
      fieldName: 'order_line_id',
      content: null
    });
    _defineProperty(this, "OrderLineName", {
      fieldName: 'order_line_name',
      content: null
    });
    _defineProperty(this, "OrderLineOffer", {
      fieldName: 'order_line_offer',
      model: Offer,
      content: null
    });
    _defineProperty(this, "offer", {
      fieldName: 'offer',
      model: Offer,
      content: null
    });
    _defineProperty(this, "OrderLineWithTrashedOffer", {
      fieldName: 'order_line_with_trashed_offer',
      model: Offer,
      content: null
    });
    _defineProperty(this, "withTrashedOffer", {
      fieldName: 'with_trashed_offer',
      model: Offer,
      content: null
    });
    _defineProperty(this, "OrderLineOfferName", {
      fieldName: 'order_line_offer_name',
      content: null
    });
    _defineProperty(this, "OrderLineOfferType", {
      fieldName: 'order_line_offer_type',
      content: null
    });
    _defineProperty(this, "OrderLineOfferDiscount", {
      fieldName: 'order_line_offer_discount',
      content: null
    });
    _defineProperty(this, "OrderLineOrder", {
      fieldName: 'order_line_order',
      model: Order,
      content: null
    });
    _defineProperty(this, "OrderLineQuantity", {
      fieldName: 'order_line_quantity',
      content: 0
    });
    _defineProperty(this, "OrderLineQuantityType", {
      fieldName: 'order_line_quantity_type',
      content: null
    });
    _defineProperty(this, "OrderLineQuantityCost", {
      fieldName: 'order_line_quantity_cost',
      content: 0
    });
    _defineProperty(this, "OrderLineQuantityConfirmed", {
      fieldName: 'order_line_quantity_confirmed',
      content: 0
    });
    _defineProperty(this, "OrderLinePrice", {
      fieldName: 'order_line_price',
      content: 0
    });
    _defineProperty(this, "OrderLineUsdPrice", {
      fieldName: 'order_line_price_usd',
      content: 0
    });
    _defineProperty(this, "OrderLineTotal", {
      fieldName: 'order_line_total',
      content: 0
    });
    _defineProperty(this, "OrderLineUsdTotal", {
      fieldName: 'order_line_total_usd',
      content: 0
    });
    _defineProperty(this, "OrderLineConfirmedTotal", {
      fieldName: 'order_line_total_confirmed',
      content: 0
    });
    _defineProperty(this, "OrderLineUsdConfirmedTotal", {
      fieldName: 'order_line_total_confirmed_usd',
      content: 0
    });
    _defineProperty(this, "OrderLineType", {
      fieldName: 'order_line_type',
      content: null
    });
    _defineProperty(this, "OrderLineDate", {
      fieldName: 'created_at',
      content: null
    });
    _defineProperty(this, "Variation", {
      fieldName: 'variation',
      model: ProductVariation,
      content: null
    });
  }
  getId() {
    return this.Id.content;
  }
  getOrderLineUsdConfirmedTotal() {
    var _this$OrderLineUsdCon;
    return !isNaN(Number((_this$OrderLineUsdCon = this.OrderLineUsdConfirmedTotal) === null || _this$OrderLineUsdCon === void 0 ? void 0 : _this$OrderLineUsdCon.content)) ? this.OrderLineUsdConfirmedTotal.content : 0;
  }
  getOrderLineConfirmedTotal() {
    var _this$OrderLineConfir;
    return !isNaN(Number((_this$OrderLineConfir = this.OrderLineConfirmedTotal) === null || _this$OrderLineConfir === void 0 ? void 0 : _this$OrderLineConfir.content)) ? this.OrderLineConfirmedTotal.content : 0;
  }
  getOffer(trashed = false) {
    if (trashed) {
      return this.withTrashedOffer.content;
    }
    return this.OrderLineOffer.content;
  }
  getProduct() {
    let offer = this.getOffer();
    return offer instanceof Offer ? offer.getProduct() : null;
  }
  getVariation() {
    return this.Variation.content;
  }
  getProductSku() {
    let product = this.getProduct();
    return product instanceof Product ? product.getSku() : null;
  }
  getVariationSku() {
    let variation = this.getVariation();
    return variation instanceof ProductVariation ? variation.getSku() : null;
  }
  getSku() {
    var _this$getVariationSku;
    return (_this$getVariationSku = this.getVariationSku()) !== null && _this$getVariationSku !== void 0 ? _this$getVariationSku : this.getProductSku();
  }
  getTotal() {
    return this.OrderLineTotal.content;
  }
  getUsdTotal() {
    return this.OrderLineUsdTotal.content;
  }
  getOfferType() {
    return this.OrderLineOfferType.content;
  }
  getType() {
    return this.OrderLineType.content;
  }
  isUpSell() {
    return this.getType() === OrderLine.UPSELL_TYPE;
  }
  getTotalConfirmed() {
    return this.OrderLineConfirmedTotal.content;
  }
  getUsdTotalConfirmed() {
    return this.OrderLineUsdConfirmedTotal.content;
  }
  getQuantity() {
    return this.OrderLineQuantity.content;
  }
  hasQuantity() {
    return this.getQuantity() > 0;
  }
  hasQuantityConfirmed() {
    return this.getQuantityConfirmed() > 0;
  }
  getQuantityConfirmed() {
    return this.OrderLineQuantityConfirmed.content;
  }
  getOrderLineType() {
    return this.OrderLineType.content;
  }
  isMain() {
    return this.getOrderLineType() === OrderLine.MAIN_TYPE;
  }
  isUpsell() {
    return this.getOrderLineType() === OrderLine.UPSELL_TYPE;
  }
  isCrossSell() {
    return this.getOrderLineType() === OrderLine.CROSS_SELL_TYPE;
  }
  getCallUpsellQuantity() {
    return this.isUpsell() ? this.getQuantityConfirmed() - this.getQuantity() : 0;
  }
  getCallUpsellTotal() {
    return this.isUpsell() ? this.getTotalConfirmed() - this.getTotal() : 0;
  }
}
_defineProperty(OrderLine, "MAIN_TYPE", 'main');
_defineProperty(OrderLine, "UPSELL_TYPE", 'upsell');
_defineProperty(OrderLine, "CROSS_SELL_TYPE", 'cross-sell');
export default OrderLine;